module.exports = __webpack_public_path__ + "img/icon-angle-up.eb9ef522.svg";